import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="p-6 md:p-8">
          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center w-12 h-12 bg-teal-100 rounded-full flex-shrink-0">
              <i className="ri-cookie-line text-2xl text-teal-600"></i>
            </div>
            
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Uso de Cookies
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación, 
                analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en "Aceptar", 
                consientes el uso de todas las cookies. Puedes gestionar tus preferencias en nuestra{' '}
                <a href="/politica-de-cookies" className="text-teal-600 hover:text-teal-700 font-medium underline">
                  Política de Cookies
                </a>.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleAccept}
                  className="px-6 py-3 bg-teal-600 text-white text-sm font-medium rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Aceptar todas
                </button>
                <button
                  onClick={handleReject}
                  className="px-6 py-3 bg-gray-100 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Rechazar
                </button>
                <a
                  href="/politica-de-cookies"
                  className="px-6 py-3 bg-white text-gray-700 text-sm font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  Configurar
                </a>
              </div>
            </div>

            <button
              onClick={handleReject}
              className="flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer flex-shrink-0"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}